module.exports = __webpack_public_path__ + "assets/img/FACTURACION.bd1fe329.svg";